import { render, staticRenderFns } from "./box.vue?vue&type=template&id=6f6f632c&scoped=true&"
import script from "./box.vue?vue&type=script&lang=js&"
export * from "./box.vue?vue&type=script&lang=js&"
import style0 from "./box.vue?vue&type=style&index=0&id=6f6f632c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f632c",
  null
  
)

export default component.exports